<ion-content>

  @if (isDemo) {
    <section>
      @if (isDemo) {
        <ion-button expand="block" (click)="startDemo()" mode="ios">
          Demo starten
          <ion-icon name="fa-arrow-right" style="margin-left: 10px;"></ion-icon>
        </ion-button>
      }
    </section>
  }
  @if (!isDemo) {

    <section>
      <swiper-container #swiper [speed]="500" [loop]="false" [allowSlideNext]="allowSwipe" [allowSlidePrev]="false">
        <swiper-slide>
          <div style="width: 100%; text-align: center;" [class.animateOut]="currentSlide == 2">
            <img id="logo" src="../../../assets/icon/favicon.png" alt="">
            <h1>Einrichtung</h1>
            <p>Bitte geben Sie die URL zu Ihrem AFS-Zeiterfassungs-Server ein und drücken Sie auf weiter.</p>
            <div style="display: flex; align-items: center; column-gap: 5px;">
              
              <afs-input-text placeholder="Server..." type="url" [(ngModel)]="serverAddress" (keydown)="serverKeyDown($event)"></afs-input-text>

              <!-- <ion-input type="url" placeholder="Server" [(ngModel)]="serverAddress" (keydown)="serverKeyDown($event)" mode="ios"></ion-input> -->
              @if (platform.is('capacitor')) {
                <afs-button type="outline" iconName="fa-qrcode" [iconOnly]="true" (click)="scanQRCode()"></afs-button>
                <!-- <ion-button (click)="scanQRCode()">
                  <ion-icon name="fa-qrcode"></ion-icon>
                </ion-button> -->
              }
            </div>

            @if (zeroconfSrv.zeroconfSever.length > 0) {
              <h2 style="font-size: 16px; margin-top: 30px;">Gefundene Server:</h2>
            }
            @for (server of zeroconfSrv.zeroconfSever; track server) {
              <ion-item class="zeroconfServer" (click)="serverClicked(server)">
                <ion-icon name="fa-server" slot="start" style="color: var(--afs-color-text);">
                </ion-icon>
                <ion-label>
                  <div>{{server.name}}</div>
                  <div>{{server.domain}}</div>
                </ion-label>
              </ion-item>
            }
          </div>
        </swiper-slide>
        <swiper-slide>
          <div style="width: 100%;" [class.animateIn]="currentSlide == 2" [class.animateOut]="currentSlide == 3">
            <h1>Anmelden</h1>
            <label>Anmeldename</label>
            <afs-input-text #usernameInput type="text" placeholder="Max" [(ngModel)]="loginCredentials.username" (keyup.enter)="inputPassword.focus()"></afs-input-text>
            <label>Passwort</label>
            <afs-input-password #inputPassword placeholder="*********" [(ngModel)]="loginCredentials.password" (keyup.enter)="login()"></afs-input-password>
          </div>
        </swiper-slide>
        <swiper-slide>
          <h1>Einstellungen</h1>
          <div style="width: 100%;" [class.animateIn]="currentSlide == 3">
            <ion-item class="toogle-item">
              <ion-label>
                <div>Fehlerberichte senden</div>
                <p class="ion-item-p">Tragen Sie dazu bei die Qualität unserer Dienstleistungen zu verbessern. <br> <a (click)="showErrorReportText()">Mehr erfahren...</a></p>
              </ion-label>
              <ion-toggle [(ngModel)]="appSettings.errorReport" slot="end" mode="ios"></ion-toggle>
            </ion-item>
            <ion-item class="toogle-item">
              <ion-label>
                <div>Automatischer Offline-Modus</div>
                <p class="ion-item-p">Bei Verbindungsproblemen zur Server, wird der Status vorübergehend lokal gespeichert und später übertragen (nicht im Terminal).</p>
              </ion-label>
              <ion-toggle [(ngModel)]="appSettings.offlineMode" slot="end" mode="ios"></ion-toggle>
            </ion-item>
            <ion-item class="toogle-item">
              <ion-label>
                <div>Darkmode</div>
                <p class="ion-item-p">Seiten-Inhalte werden dunkel dargestellt.</p>
              </ion-label>
              <ion-toggle [(ngModel)]="appSettings.darkmode" slot="end" (ngModelChange)="toggleDarkmode()" mode="ios"></ion-toggle>
            </ion-item>
          </div>
        </swiper-slide>
      </swiper-container>
    </section>
  }
</ion-content>

@if (!isDemo) {
  <ion-footer class="ion-no-border">
    <ion-toolbar class="ion-padding">

      <afs-button [fullWidth]="true" (click)="continue()">
        {{currentSlide == 1 ? 'Weiter' : currentSlide == 2 ? 'Anmelden' : 'Abschließen'}}
        <!-- @if (currentSlide != 3) {
          <ion-icon name="fa-arrow-right" style="margin-left: 10px;"></ion-icon>
        } -->
      </afs-button>
    </ion-toolbar>
  </ion-footer>
}
